import { StepsInterface } from '../interfaces/steps.interface';
import AppletSubgroupTypeEnum from '../../../models/applet/applet-subgroup-type.enum';
import IconErrorCarFrontComponent from '../photos/car/error/icon-error-front-car.component';
import IconErrorCarBackComponent from '../photos/car/error/icon-error-back-car.component';
import IconErrorMotorComponent from '../photos/car/error/icon-error-motor-car.component';
import IconErrorPedometerComponent from '../photos/car/error/icon-error-pedometer.component';
import IconErrorCarDocumentComponent from '../photos/car/error/icon-error-document.component';

import iconFrontDiagonalPassenger from '../../../assets/images/inspection/icon-front-diagonal-passnger.png';
import iconFrontDiagonal from '../../../assets/images/inspection/icon-front-diagonal.png';
import iconBackDiagonalPassenger from '../../../assets/images/inspection/icon-back-diagonal-passenger.png';
import iconBackDiagonal from '../../../assets/images/inspection/icon-back-diagonal.png';
import iconMotor from '../../../assets/images/inspection/icon-motor.png';
import iconChassi from '../../../assets/images/inspection/icon-chassi.png';
import iconOdometer from '../../../assets/images/inspection/icon-odometer.png';
import iconSteppe from '../../../assets/images/inspection/icon-steppe.png';
import iconCrlv from '../../../assets/images/inspection/crlv.png';

const stepsContent: StepsInterface[] = [
  {
    photoImage: iconFrontDiagonal,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, assegure-se que <strong>a placa, os faróis dianteiros e toda a lateral do passageiro</strong> do veículo estejam visíveis.',
      photoComponent: IconErrorCarFrontComponent,
    },
    type: AppletSubgroupTypeEnum.FRONT_DRIVER_DIAGONAL,
  },
  {
    photoImage: iconFrontDiagonalPassenger,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente.',
      photoComponent: IconErrorCarFrontComponent,
    },
    type: AppletSubgroupTypeEnum.FRONT_PASSENGER_DIAGONAL,
  },
  {
    photoImage: iconBackDiagonalPassenger,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente.',
      photoComponent: IconErrorCarBackComponent,
    },
    type: AppletSubgroupTypeEnum.REAR_PASSENGER_DIAGONAL,
  },
  {
    photoImage: iconBackDiagonal,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, assegure-se que <strong>a placa, os faróis traseiros e toda a lateral do motorista do veículo</strong> estejam visíveis',
      photoComponent: IconErrorCarBackComponent,
    },
    type: AppletSubgroupTypeEnum.REAR_DRIVER_DIAGONAL,
  },
  {
    photoImage: iconMotor,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, use o celular na horizontal. Abra o capô do seu veículo e certifique-se de capturar o motor inteiro na foto.',
      photoComponent: IconErrorMotorComponent,
    },
    type: AppletSubgroupTypeEnum.MOTOR,
  },
  {
    photoImage: iconChassi,
    error: {
      title: '',
      text: '',
      photoComponent: null,
    },
    type: AppletSubgroupTypeEnum.CHASSIS,
  },
  {
    photoImage: iconOdometer,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, use  o celular na horizontal. Ligue o veículo e tire uma foto do painel com o motor ligado.',
      photoComponent: IconErrorPedometerComponent,
    },
    type: AppletSubgroupTypeEnum.ODOMETER,
  },
  {
    photoImage: iconSteppe,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, Assegure-se que o <strong>documento esteja aberto, com uma foto legível mostrando todos os dados do CRLV.</strong>',
      photoComponent: IconErrorCarDocumentComponent,
    },
    type: AppletSubgroupTypeEnum.STEPPE,
  },
  {
    photoImage: iconCrlv,
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, Assegure-se que o <strong>documento esteja aberto, com uma foto legível mostrando todos os dados do CRLV.</strong>',
      photoComponent: IconErrorCarDocumentComponent,
    },
    type: AppletSubgroupTypeEnum.DOCUMENT,
  },
  {
    photoImage: '',
    error: {
      title: 'Não conseguimos identificar a foto',
      text: 'Verifique se a imagem está correta e tente novamente. Lembre-se, assegure-se que <strong>a placa, os faróis frontais do veículo</strong> estejam visíveis',
      photoComponent: IconErrorCarFrontComponent,
    },
    type: AppletSubgroupTypeEnum.FRONT,
  },
];

export default stepsContent;
